import Vue from 'vue'
import App from './App.vue'
import router from './router/index';
import store from "@/store";
import ajax from './config/ajax'
import { Lazyload } from 'vant';
Vue.use(Lazyload);
Vue.prototype.$ajax = ajax; // 绑定请求封装
Vue.config.productionTip = false
Vue.prototype.$store = store
Vue.prototype.$dic = store.state.dic
Vue.prototype.$imageUrl = 'http://218.197.101.84/onefile'
new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
